import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {RouterModule} from "@angular/router";
import {LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import {ROUTES} from "./app.routes";
import { AppComponent } from './app.component';

import { AuthGuard } from './util/authGuard';

//3th party
import {ToastyModule} from 'ng2-toasty';

//Services
import { UsuarioService } from './servicios/usuario.service';
import { AlertService } from './servicios/alert.service';
// App views
import {MinorViewModule} from "./views/minor-view/minor-view.module";
import {RegisterModule} from "./views/register/register.module";

// App modules/components
import {LayoutsModule} from "./components/common/layouts/layouts.module";
import { viewsModule } from './modules/view.module';
import { ServicesModule } from './modules/services.module';
import { HttpService } from './config/http.service';
import { BsModalModule } from 'ng2-bs3-modal';
import { MessagingService } from './servicios/messaging.service';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { environment } from '../environments/environment';
// import { flotModule } from 'ng2modules-flot';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BsModalModule,
    // flotModule,
    // Angular modules
    BrowserModule,
    HttpModule,
    viewsModule,

    // Views
    LayoutsModule,
    MinorViewModule,
    RegisterModule,

    // Modules
    ServicesModule,
    RouterModule.forRoot(ROUTES),
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    AuthGuard,
    HttpService,
    MessagingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts